// Inject pointer-events fix with !important to override inheritance
const zoomStyle = document.createElement('style');
zoomStyle.textContent = `
  .product__modal-opener { pointer-events: none; }
  .product__modal-opener .product__media { pointer-events: auto !important; }
  .product__modal-opener .product__media img { pointer-events: auto !important; }
  .product__media-icon--lightbox { display: none; }
`;
document.head.appendChild(zoomStyle);

let overlay;

function createOverlay(image) {
  if (overlay) overlay.remove();
  overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function moveWithHover(image, event, zoomRatio) {
  if (!overlay) return;
  const ratio = image.height / image.width;
  const container = overlay.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function tagGalleryImages() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;
  gallery.querySelectorAll('.product__media img:not(.image-magnify-hover):not(.image-magnify-lightbox)').forEach(img => {
    img.classList.add('image-magnify-hover');
  });
}

function initDelegatedZoom(zoomRatio) {
  document.addEventListener('mouseover', (event) => {
    const image = event.target.closest('.image-magnify-hover');
    if (!image) return;

    // Always clean up any existing overlay first
    if (overlay) {
      overlay.remove();
      overlay = null;
    }

    createOverlay(image);
    moveWithHover(image, event, zoomRatio);

    overlay.addEventListener('mousemove', (e) => moveWithHover(image, e, zoomRatio));
    overlay.addEventListener('mouseleave', () => {
      if (overlay) { overlay.remove(); overlay = null; }
    });
  });
}

function observeGallery() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;
  new MutationObserver(() => tagGalleryImages()).observe(gallery, { childList: true, subtree: true });
}

tagGalleryImages();
initDelegatedZoom(2);
observeGallery();
